import React, { Fragment } from 'react';
import Head from 'next/head';
import { observer } from 'mobx-react';
import { Disclosure, Menu, Transition } from '@headlessui/react';
import { MailIcon, PhoneIcon, ChevronDownIcon } from '@heroicons/react/outline';
import { makeObservable } from 'mobx';
import 'tailwindcss/tailwind.css';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { Store } from '../../pagepart/store/Store';
import { StoreContext } from 'src/pagepart/utils';
import { Env } from '../../env/Env';
import { ServerProps } from '../../pagepart/portal/utils';
import { TopbarNavigationDropdown } from '../../tailwind/info/TopbarNavigationDropdown';
import { InfoTopbar } from '../../tailwind/info/InfoTopbar';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export async function getServerSideProps(rawContext) {
  const { env, userEnv, requestEnv } = await Env.forNextContext(rawContext);

  return {
    props: {
      ...env.transfer,
    },
  };
}

const people = [
 /* {
    name: 'Michael Hicke',
    role: 'Projektverantwortlicher und Programmierung',
    imageUrl: '/images/michaelhicke.png',
    bio: 'Michael entwickelt die Software für Schlaukopf.de',
  },
  {
    name: 'Dr. med. Agathe Hicke',
    role: 'Inhaltserstellung',
    imageUrl: '/images/agathehicke.png',
    bio: 'Agathe erstellt und vertont die Fragensammlung.',
  },
  {
    name: 'Annette Roder',
    role: 'Android und iOS App',
    imageUrl: '',
    bio: (
      <span>
        Annette entwickelt mit ihrer Firma Appsistance in München die Apps{' '}
        <a href="https://play.google.com/store/apps/details?id=de.appsistance.abfragerapp" target="_blank">
          Schlaukopf für Android
        </a>{' '}
        und{' '}
        <a href="https://apps.apple.com/de/app/schlaukopf/id949264613?mt=8&ign-mpt=uo%3D4" target="_blank">
          Schlaukopf für iOS
        </a>
        .
      </span>
    ),
  },
  {
    name: 'Bernd Dietrich',
    role: 'Qualitätssicherung',
    imageUrl: '/images/bernddietrich.png',
    bio: 'Als gelernter Industriemeister im Ruhestand hilft Bernd Dietrich bei der Qualitätssicherung der Fragen.',
  },
  // More people...*/
];

const faqs = [
  {
    question: 'Kosten',
    answer:
      'Das Angebot bei schlaukopf.de ist kostenlos und werbefinanziert.\n' +
      'Optional bieten wir eine Premium-Version an, welche werbefrei ist und zusätzliche Funktionen beinhaltet.',
  },
  {
    question: 'Allgemeines',
    answer:
      'Schlaukopf.de erbringt Leistungen nur auf Grundlage dieser Vertragsbedingungen. Schlaukopf.de bietet die Möglichkeit, online zu lernen und das gelernte Wissen abzufragen.',
  },
  // More questions...
];

@observer
class InfoImpressum extends React.Component<ServerProps<typeof getServerSideProps>> {
  constructor(props) {
    super(props);
    // makeObservable(this);
  }

  @memoize
  get store() {
    return Store.forApp(this);
  }

  setupPage(store: Store) {
    store.portalStore.metaTitle = 'Schlaukopf Impressum';
  }

  render() {
    const { userData } = this.props;

    return (
      <StoreContext.Provider value={this.store}>
        <Head>
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <title>Schlaukopf - Impressum</title>
          <meta name="Description" content="Impressum der Webseite Schlaukopf.de." />
          <meta name="Keywords" content="Schlaukopf,Impressum" />
          <meta name="Language" content="de" />
          <meta name="robots" content="index,follow" />
        </Head>
        <div className="antialiased font-sans  bg-gray-50" style={{ minHeight: '100vh' }}>
          <InfoTopbar />
          <div>
            <main>
              <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                {/* Replace with your content */}
                <div className="relative bg-white">
                  <div className="absolute inset-0">
                    <div className="absolute inset-y-0 left-0 w-1/2 bg-gray-50" />
                  </div>
                  <div className="relative max-w-7xl mx-auto lg:grid lg:grid-cols-5">
                    <div className="bg-gray-50 py-16 px-4 sm:px-6 lg:col-span-2 lg:px-8 lg:py-24 xl:pr-12">
                      <div className="max-w-lg mx-auto">
                        <h2 className="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl">Impressum</h2>
                        <p className="mt-3 text-lg leading-6 text-gray-500">
                          Anbieter dieser Web-Seite und verantwortlich nach § 5 TMG.
                        </p>
                        <dl className="mt-8 text-base text-gray-500">
                          <div>
                            <dt className="sr-only">Anschrift</dt>
                            <dd>
                              <p>Digitalwerk eG</p>
                              <p>Bachstr. 6</p>
                              <p>72810 Gomaringen</p>
                            </dd>
                          </div>

                          <div className="mt-6">
                            <dt className="sr-only">Telefon</dt>
                            <dd className="flex">
                              <PhoneIcon className="flex-shrink-0 h-6 w-6 text-gray-400" aria-hidden="true" />
                              <span className="ml-3">+49 (07072) 2650</span>
                            </dd>
                          </div>
                          <div className="mt-3">
                            <dt className="sr-only">Email</dt>
                            <dd className="flex">
                              <MailIcon className="flex-shrink-0 h-6 w-6 text-gray-400" aria-hidden="true" />
                              <span className="ml-3">email@schlaukopf.de</span>
                            </dd>
                          </div>
                        </dl>
                        <p className="mt-6 text-base text-gray-500">SteuerID: DE 444795724</p>
                      </div>
                      <div className="mt-6 text-base text-gray-500">
                        <dd>
                          <p>Vertreten durch den Vorstand:</p>
                          <p>Michael Hicke</p>
                        </dd>
                      </div>
                      <div className="mt-6 text-base text-gray-500">
                        <dd>
                          <p>Eingetragen im Genossenschaftsregister</p>
                          <p>Registergericht: Amtsgericht Stuttgart</p>
                          <p>Registernummer: GnR 720272</p>
                        </dd>
                      </div>
                    </div>
                    <div className="bg-white py-16 px-4 sm:px-6 lg:col-span-3 lg:py-24 lg:px-8 xl:pl-12">
                      <div className="max-w-lg mx-auto lg:max-w-none">
                        {/* Begin WHITE BLOCK */}

                        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                          <svg
                            className="absolute top-full right-full transform translate-x-1/3 -translate-y-1/4 lg:translate-x-1/2 xl:-translate-y-1/2"
                            width={404}
                            height={404}
                            fill="none"
                            viewBox="0 0 404 404"
                            role="img"
                            aria-labelledby="svg-workcation"
                          >
                            <title id="svg-workcation">Workcation</title>
                            <defs>
                              <pattern
                                id="ad119f34-7694-4c31-947f-5c9d249b21f3"
                                x={0}
                                y={0}
                                width={20}
                                height={20}
                                patternUnits="userSpaceOnUse"
                              >
                                <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                              </pattern>
                            </defs>
                          </svg>

                          <div className="relative">
                            <blockquote className="mt-10">
                              <a
                                className="block w-full py-3 px-5 text-center bg-white border border-transparent rounded-md shadow-md text-base font-medium text-indigo-700 hover:bg-gray-50 sm:inline-block sm:w-auto"
                                href="/info/faq"
                              >
                                Antworten auf häufige Fragen
                              </a>
                            </blockquote>
                          </div>
                        </div>

                        {/* End WHITE BLOCK */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* /End replace */}
              </div>
              {/*
              <div className="bg-white">
                <div className="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
                  <div className="space-y-12 lg:grid lg:grid-cols-3 lg:gap-8 lg:space-y-0">
                    <div className="space-y-5 sm:space-y-4">
                      <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl">Über uns</h2>
                      <p className="text-xl text-gray-500">Unser Ziel ist es, tolle Lernangebote für möglichst viele Kinder anzubieten.</p>
                    </div>
                    <div className="lg:col-span-2">
                      <ul className="space-y-12 sm:divide-y sm:divide-gray-200 sm:space-y-0 sm:-mt-8 lg:gap-x-8 lg:space-y-0">
                        {people.map(person => (
                          <li key={person.name} className="sm:py-8">
                            <div className="space-y-4 sm:grid sm:grid-cols-3 sm:items-start sm:gap-6 sm:space-y-0">
                              <div className="aspect-w-3 aspect-h-2 sm:aspect-w-3 sm:aspect-h-4">
                                <img className="object-cover shadow-lg rounded-lg" src={person.imageUrl} alt="" />
                              </div>
                              <div className="sm:col-span-2">
                                <div className="space-y-4">
                                  <div className="text-lg leading-6 font-medium space-y-1">
                                    <h3>{person.name}</h3>
                                    <p className="text-indigo-600">{person.role}</p>
                                  </div>
                                  <div className="text-lg">
                                    <p className="text-gray-500">{person.bio}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

               */}

            </main>
          </div>
        </div>
      </StoreContext.Provider>
    );
  }
}

export default InfoImpressum;
